
import MHeader from '../Header/Header.vue';
import _ from 'lodash';
import Api from '@/utils/api';
import {
getAddrList,
saveAddr
} from '../../api';
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import querystring from 'vux/src/tools/querystring/index.js'
import value2name from 'vux/src/filters/value2name.js'

export default {
components: {
MHeader,
Confirm,
Group,
Cell,
XInput,
XAddress,
Datetime,
XTextarea,
Alert,
XSwitch
},
data() {
return {
list: [],
show1: false,
addressData: ChinaAddressData,
form: {
name: '',
mobileNumber: '',
area: '',
areaCode: [],
location: '',
default: false
},
isAlert: false
}
},
methods: {
getAddrList() {
var that = this;
this.$store.commit('showIsLoading');
getAddrList().then(res => {
if (res.data.error_code) {
alert(res.data.msg)
return;
};
let arr = res.data.addrList.list;
this.list = arr.reverse();
console.log(arr);
});
},
save() {
if (!this.form.name) {
this.$store.commit('updateToast', {
text: '请填写收货人姓名',
show: true
});
return;
};
if (!this.form.mobileNumber) {
this.$store.commit('updateToast', {
text: '请填写联系方式',
show: true
});
return;
};
if (!this.form.areaCode.length) {
this.$store.commit('updateToast', {
text: '请填写所在地区',
show: true
});
return;
};
if (!this.form.location) {
this.$store.commit('updateToast', {
text: '请填写详细地址',
show: true
});
return;
};
if (!(/^1[345678]\d{9}$/.test(this.form.mobileNumber))) {
this.isAlert = true;
return false;
};
this.form.area = value2name(this.form.areaCode, ChinaAddressData)
if(this.$route.params.pathName == 'add'){
Api.addAddress(this.form)
.then(res => {
this.$router.go(-1)
})
}else{
Api.updateAddress(this.form)
.then(res => {
this.$router.go(-1)
})
}









}
},
mounted() {
var pathName = this.$route.params.pathName;
if (pathName == 'add') {
this.form.default = true;
} else {
let data = JSON.parse(pathName);
this.form = data
};

}
}



// WEBPACK FOOTER //
// ./src/components/AddAddress/AddAddress.vue